import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import statusHttpRequest from "../../utils/statusHttpRequest";


const initialState = {
    loading: false,
    error: null,
    registerCorporate: [],
    corporateInfo: "",
    principalDirectors: "",
    designatedOfficer: "",
    refereeInfo: "",
};

export const createCorporateRegistration = createAsyncThunk(
    "corporateRegistration/createCorporateRegistration",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await httpRequest(
                `${BASE_URL}/v2/Application/corporate-registration`,
                "post",
                arg
            );
            if (response?.response?.data) {
                throw response;
            }
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const createCorporateApplicationForm = createAsyncThunk(
    "corporateRegistration/createCorporateApplicationForm",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await httpRequest(
                `${BASE_URL}/v2/Application/corporate-application-form`,
                "post",
                arg
            );
            if (response?.response?.data) {
                throw response;
            }
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const editCorporateApplicationForm = createAsyncThunk(
    "corporateRegistration/updateCorporateApplicationForm",
    async (arg, { rejectWithValue }) => {
        try {
            const response = await httpRequest(
                `${BASE_URL}/v2/Application/corporate/update`,
                "post",
                arg
            );
            if (response?.response?.data) {
                throw response;
            }
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const fetchCorporateApplication = createAsyncThunk(
    "corporateRegistration/fetchCorporateApplication",
    async () => {
        return statusHttpRequest(`${BASE_URL}/v2/Application/corporate-application`,);
    }
);

const corporateRegistrationSlice = createSlice({
    name: "corporateRegistration",
    initialState,
    reducers: {
        setCorporateInfo: (state, { payload }) => {
            state.corporateInfo = payload;
        },
        setPrincipalDirectors: (state, { payload }) => {
            state.principalDirectors = payload;
        },
        setDesignatedOfficer: (state, { payload }) => {
            state.designatedOfficer = payload;
        },
        setRefereeInfo: (state, {payload}) => {
            state.refereeInfo = payload;
        },
    },

    extraReducers: (builder) => {
        //Register student:
        builder.addCase(createCorporateRegistration.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createCorporateRegistration.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.registerStudent = payload;
            state.error = null;
        });
        builder.addCase(createCorporateRegistration.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = payload?.error?.description;
        });


        // Create corporate Application Form:
        builder.addCase(createCorporateApplicationForm.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createCorporateApplicationForm.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.error = null;
        });
        builder.addCase(createCorporateApplicationForm.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = payload?.error?.description;
        });

        // get corporate Application Form:
        builder.addCase(fetchCorporateApplication.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchCorporateApplication.fulfilled, (state, { payload }) => {
            state.loading = false;
            state.registerStudent = payload;
            state.error = null;
        });
        builder.addCase(fetchCorporateApplication.rejected, (state, { payload }) => {
            state.loading = false;
            state.error = payload?.error?.description;
        });

    }

});

export const { setCorporateInfo, setPrincipalDirectors, setDesignatedOfficer,setRefereeInfo } = corporateRegistrationSlice.actions;
export default corporateRegistrationSlice.reducer;